export default function CStructsPointers() {
  return <h2>C Structs Pointers</h2>;
}
